import { normalize/* , schema */ } from 'normalizr'

const Entities = (props) => {
  const { data, schema } = props
  return normalize(data, schema)
}

export default Entities
